<template>
    <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
        <g fill="#FFF" fill-rule="nonzero">
            <path d="M8.556 0v1.556h2.788L3.698 9.2l1.1 1.1 7.646-7.645v2.788H14V0z" />
            <path
                d="M12.444 12.444H1.556V1.556H7V0H1.556C.696 0 0 .696 0 1.556v10.888C0 13.304.696 14 1.556 14h10.888c.86 0 1.556-.696 1.556-1.556V7h-1.556v5.444z"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "Window Open",
};
</script>
